export const STEPS = [
  'intro',
  'email',
  'landing',
  'appliance-status',
  'scan-model-label',
  'model-lookup',
  'scan-countertop',
  'countertop-results',
  'scan-undersink',
  'undersink-results',
  'qa',
  'review',
  'schedule',
  'confirmation',
] as const

export type Step = typeof STEPS[number]

export const DEFAULT_STEP: Step = 'email'

export const isStep = (v: string | null | undefined): v is Step =>
  v != null && (STEPS as readonly string[]).includes(v)
